/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SplatRouteImport } from './routes/$'
import { Route as EventsIndexRouteImport } from './routes/events.index'
import { Route as VenuesNewRouteImport } from './routes/venues.new'
import { Route as EventsIdRouteImport } from './routes/events.$id'
import { Route as VenuesIdStudioRouteImport } from './routes/venues.$id.studio'
import { Route as VenuesIdSetupRouteImport } from './routes/venues.$id.setup'
import { Route as VenuesIdCanvasRouteImport } from './routes/venues.$id.canvas'

const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const EventsIndexRoute = EventsIndexRouteImport.update({
  id: '/events/',
  path: '/events/',
  getParentRoute: () => rootRouteImport,
} as any)
const VenuesNewRoute = VenuesNewRouteImport.update({
  id: '/venues/new',
  path: '/venues/new',
  getParentRoute: () => rootRouteImport,
} as any)
const EventsIdRoute = EventsIdRouteImport.update({
  id: '/events/$id',
  path: '/events/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const VenuesIdStudioRoute = VenuesIdStudioRouteImport.update({
  id: '/venues/$id/studio',
  path: '/venues/$id/studio',
  getParentRoute: () => rootRouteImport,
} as any)
const VenuesIdSetupRoute = VenuesIdSetupRouteImport.update({
  id: '/venues/$id/setup',
  path: '/venues/$id/setup',
  getParentRoute: () => rootRouteImport,
} as any)
const VenuesIdCanvasRoute = VenuesIdCanvasRouteImport.update({
  id: '/venues/$id/canvas',
  path: '/venues/$id/canvas',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/$': typeof SplatRoute
  '/events/$id': typeof EventsIdRoute
  '/venues/new': typeof VenuesNewRoute
  '/events/': typeof EventsIndexRoute
  '/venues/$id/canvas': typeof VenuesIdCanvasRoute
  '/venues/$id/setup': typeof VenuesIdSetupRoute
  '/venues/$id/studio': typeof VenuesIdStudioRoute
}
export interface FileRoutesByTo {
  '/$': typeof SplatRoute
  '/events/$id': typeof EventsIdRoute
  '/venues/new': typeof VenuesNewRoute
  '/events': typeof EventsIndexRoute
  '/venues/$id/canvas': typeof VenuesIdCanvasRoute
  '/venues/$id/setup': typeof VenuesIdSetupRoute
  '/venues/$id/studio': typeof VenuesIdStudioRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/$': typeof SplatRoute
  '/events/$id': typeof EventsIdRoute
  '/venues/new': typeof VenuesNewRoute
  '/events/': typeof EventsIndexRoute
  '/venues/$id/canvas': typeof VenuesIdCanvasRoute
  '/venues/$id/setup': typeof VenuesIdSetupRoute
  '/venues/$id/studio': typeof VenuesIdStudioRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/$'
    | '/events/$id'
    | '/venues/new'
    | '/events/'
    | '/venues/$id/canvas'
    | '/venues/$id/setup'
    | '/venues/$id/studio'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/$'
    | '/events/$id'
    | '/venues/new'
    | '/events'
    | '/venues/$id/canvas'
    | '/venues/$id/setup'
    | '/venues/$id/studio'
  id:
    | '__root__'
    | '/$'
    | '/events/$id'
    | '/venues/new'
    | '/events/'
    | '/venues/$id/canvas'
    | '/venues/$id/setup'
    | '/venues/$id/studio'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  SplatRoute: typeof SplatRoute
  EventsIdRoute: typeof EventsIdRoute
  VenuesNewRoute: typeof VenuesNewRoute
  EventsIndexRoute: typeof EventsIndexRoute
  VenuesIdCanvasRoute: typeof VenuesIdCanvasRoute
  VenuesIdSetupRoute: typeof VenuesIdSetupRoute
  VenuesIdStudioRoute: typeof VenuesIdStudioRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/events/': {
      id: '/events/'
      path: '/events'
      fullPath: '/events/'
      preLoaderRoute: typeof EventsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/venues/new': {
      id: '/venues/new'
      path: '/venues/new'
      fullPath: '/venues/new'
      preLoaderRoute: typeof VenuesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/events/$id': {
      id: '/events/$id'
      path: '/events/$id'
      fullPath: '/events/$id'
      preLoaderRoute: typeof EventsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/venues/$id/studio': {
      id: '/venues/$id/studio'
      path: '/venues/$id/studio'
      fullPath: '/venues/$id/studio'
      preLoaderRoute: typeof VenuesIdStudioRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/venues/$id/setup': {
      id: '/venues/$id/setup'
      path: '/venues/$id/setup'
      fullPath: '/venues/$id/setup'
      preLoaderRoute: typeof VenuesIdSetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/venues/$id/canvas': {
      id: '/venues/$id/canvas'
      path: '/venues/$id/canvas'
      fullPath: '/venues/$id/canvas'
      preLoaderRoute: typeof VenuesIdCanvasRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  SplatRoute: SplatRoute,
  EventsIdRoute: EventsIdRoute,
  VenuesNewRoute: VenuesNewRoute,
  EventsIndexRoute: EventsIndexRoute,
  VenuesIdCanvasRoute: VenuesIdCanvasRoute,
  VenuesIdSetupRoute: VenuesIdSetupRoute,
  VenuesIdStudioRoute: VenuesIdStudioRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
